import React, { useState, useEffect } from 'react';
import { FaBitcoin, FaEthereum } from 'react-icons/fa';
import { SiSolana } from "react-icons/si";
import { RiXrpFill } from "react-icons/ri";
import './IconRow.css';

const IconRow = () => {
  const [prices, setPrices] = useState({
    bitcoin: { current: null, change: null },
    ethereum: { current: null, change: null },
    solana: { current: null, change: null },
    xrp: { current: null, change: null }
  });

  useEffect(() => {
    const fetchPrices = async () => {
      try {
        const response = await fetch(
          'https://api.coingecko.com/api/v3/simple/price?ids=bitcoin,ethereum,solana,ripple&vs_currencies=eur&include_24hr_change=true'
        );
        const data = await response.json();
        setPrices({
          bitcoin: {
            current: data.bitcoin.eur,
            change: data.bitcoin.eur_24h_change
          },
          ethereum: {
            current: data.ethereum.eur,
            change: data.ethereum.eur_24h_change
          },
          solana: {
            current: data.solana.eur,
            change: data.solana.eur_24h_change
          },
          xrp: {
            current: data.ripple.eur,
            change: data.ripple.eur_24h_change
          }
        });
      } catch (error) {
        console.error('Error fetching prices:', error);
      }
    };

    fetchPrices();
    // Update prices every 60 seconds
    const interval = setInterval(fetchPrices, 60000);
    return () => clearInterval(interval);
  }, []);

  const formatPrice = (price) => {
    if (!price) return '...';
    return new Intl.NumberFormat('de-DE', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(price);
  };

  const formatChange = (change) => {
    if (change === null) return '...';
    const formattedChange = change.toFixed(2);
    return `${formattedChange}%`;
  };

  return (
    <div className="crypto-prices-header">
      <div className="crypto-price-item">
        <FaBitcoin size={20} color="#F7931A" />
        <div className="price-info">
          <span className="crypto-price">{formatPrice(prices.bitcoin.current)}</span>
          <span className={`price-change ${prices.bitcoin.change >= 0 ? 'positive' : 'negative'}`}>
            {formatChange(prices.bitcoin.change)}
          </span>
        </div>
      </div>
      <div className="crypto-price-item">
        <FaEthereum size={20} color="#3C3C3D" />
        <div className="price-info">
          <span className="crypto-price">{formatPrice(prices.ethereum.current)}</span>
          <span className={`price-change ${prices.ethereum.change >= 0 ? 'positive' : 'negative'}`}>
            {formatChange(prices.ethereum.change)}
          </span>
        </div>
      </div>
      <div className="crypto-price-item">
        <RiXrpFill size={18} color="#3C3C3D" />
        <div className="price-info">
          <span className="crypto-price">{formatPrice(prices.xrp.current)}</span>
          <span className={`price-change ${prices.xrp.change >= 0 ? 'positive' : 'negative'}`}>
            {formatChange(prices.xrp.change)}
          </span>
        </div>
      </div>
      <div className="crypto-price-item">
        <SiSolana size={20} color="#3C3C3D" />
        <div className="price-info">
          <span className="crypto-price">{formatPrice(prices.solana.current)}</span>
          <span className={`price-change ${prices.solana.change >= 0 ? 'positive' : 'negative'}`}>
            {formatChange(prices.solana.change)}
          </span>
        </div>
      </div>
      {/* Solana-Icon als Bild
      <div style={styles.icon}>
        <img src="https://cryptologos.cc/logos/solana-sol-logo.png" alt="Solana" width={48} height={48} />
      </div>/
      */}
    </div>
  );
};

const styles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '10px',
    padding: '20px',
  },
  icon: {
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
  }
};

export default IconRow;
